module.exports = __webpack_public_path__ + "img/coca-cola@2x.bb52a519.png";